import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, Grid, Link } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { LLS_HOME_URL, TELEPERFORMANCE_PRIVACY_URL } from "../../config/urls";

const Footer: FC = () => {
  const { t } = useTranslation();

  return (
    <footer>
      <Box
        sx={{
          background: "#002b50",
          color: "#fff",
          fontSize: 14,
          padding: "19px 0",
          "& a": {
            color: "#fff",
            textDecoration: "underline"
          }
        }}
      >
        <Box mx={5}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={6}>
              <Box
                dangerouslySetInnerHTML={{
                  __html: t("footer.copyright", {
                    teleperformancePrivacy: TELEPERFORMANCE_PRIVACY_URL,
                    llsDotCom: LLS_HOME_URL,
                    fullYear: new Date().getFullYear()
                  })
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: "flex", justifyContent: { xs: "flex-start", md: "flex-end" }, gap: 3 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <EmailIcon fontSize="small" />
                  <Link href={`mailto:${t("footer.contact.email")}`} underline="hover">
                    {t("footer.contact.email")}
                  </Link>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <PhoneIcon fontSize="small" />
                  <Link href={`tel:${t("footer.contact.phone").replace(/[^0-9]/g, "")}`} underline="hover">
                    {t("footer.contact.phone")}
                  </Link>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </footer>
  );
};

export default Footer;
